import { useMemo } from 'react'
import { detectBrowser } from './detectBrowser'
import { BrowserType } from './browser.types'

export const useBrowser = (): BrowserType => useMemo(() => detectBrowser(), [])
